import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { NavService } from '../../_services/_nav.service';
import { EstructuraPecuaria } from '../../_models/estructura-pecuaria';
import { EstructuraPecuariaService } from '../../_services/estructura-pecuaria.service';
import { EstructuraPecuariaProcesoProductivo } from '../../_models/estructura-pecuaria-proceso-productivo';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { ProcesoProductivo } from '../../_models/proceso-productivo';
import { ProcesoVariableIncidenciaService } from '../../_services/proceso-variable-incidencia.service';
import { ProcesoVariableIncidencia } from '../../_models/proceso-variable-incidencia';

@Component( {
  selector: 'app-proceso-productivo-variable-incidencia',
  templateUrl: 'proceso-productivo-variable-incidencia.component.html'
} )

export class ProcesoProductivoVariableIncidenciaComponent implements OnInit {
  formulario: FormGroup;
  @Input() procesoProductivo: ProcesoProductivo;
  variableIncidencia: ProcesoVariableIncidencia;

  /** Listas */
  lisVariablesIncidencias: ProcesoVariableIncidencia[] = [];

  columnas: any[] = [];
  carInformacionInicial = true;
  rowGroupMetadata: any;
  tabSeleccionado = 'VARIABLE';
  submitted = false;
  guardando = false;
  carTabla = true;
  @ViewChild('dt') tabla: Table;
  menu: Funcionalidad = new Funcionalidad();


  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private serProcesoVariableIncidencia: ProcesoVariableIncidenciaService,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private navServicio: NavService,
    private router: Router,
    private autServicio: AutenticacionService,
    private serLista: ListaService
  ) {
  }

  ngOnInit() {

    if ( this.procesoProductivo && (this.procesoProductivo.idProcesoProductivo !== '' && this.procesoProductivo.idProcesoProductivo !== null && this.procesoProductivo.idProcesoProductivo !== undefined) ) {
      /** Se carga la variables de incidencia */
      this.serProcesoVariableIncidencia.obtenerPorProcesoProductivo( this.procesoProductivo.idProcesoProductivo ).subscribe( registros => {
        this.lisVariablesIncidencias = registros;
        this.cargarInformacionInicial();
      } );
    }

  }

  cargarInformacionInicial() {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/proceso-productivo' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'LBL_CODIGO' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'PROCESOPRODUCTIVO.LBL_VARIAINCID' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.formulario = this.fb.group( {
      idProcesoProductivo: [ this.procesoProductivo ? this.procesoProductivo.idProcesoProductivo : null, [ Validators.required ] ],
      idProcesoVariableIncidencia: [ this.variableIncidencia ? this.variableIncidencia.idProcesoVariableIncidencia : null ],
      codigo: [ this.variableIncidencia ? this.variableIncidencia.codigo : null, [ Validators.required ] ],
      variableIncidencia: [ this.variableIncidencia ? this.variableIncidencia.variableIncidencia : null, [ Validators.required ] ],
      indicadorHabilitado: [ this.variableIncidencia ? this.variableIncidencia.indicadorHabilitado : true, [ Validators.required ] ]
    } );

    this.carTabla = false;
    this.carInformacionInicial = false;

  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      this.carTabla = true;
      const formulario = this.formulario.getRawValue();
      /** Actualizar Variable incidencia */
      if ( formulario.idProcesoVariableIncidencia ) {
        if ( this.verificarCodigo( formulario ) ) {
          this.navServicio.setMesage( 0, {
            severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'PROCESOPRODUCTIVO.MSG_ERRORCODIGO' )
          } );
          this.guardando = false;
          this.submitted = false;
          this.carTabla = false;
        } else {
          this.serProcesoVariableIncidencia.actualizar( formulario ).subscribe( regActualizado => {
            this.lisVariablesIncidencias = [];
            this.serProcesoVariableIncidencia.obtenerPorProcesoProductivo( this.procesoProductivo.idProcesoProductivo ).subscribe( registros => {
              this.lisVariablesIncidencias = registros;
              this.guardando = false;
              this.submitted = false;
              this.carTabla = false;
              this.variableIncidencia = null;
              this.formulario.reset();
              this.f.idProcesoProductivo.setValue( this.procesoProductivo.idProcesoProductivo );
              this.f.indicadorHabilitado.setValue( true );
              this.navServicio.setMesage( 0, {
                severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
                detail: this.navServicio.buscarMensaje( 'ESTRUCTURAAGRICOLA.LBL_REGACTU' )
              } );
            } );
          } );
        }
      } else {
        if ( this.verificarCodigo( formulario ) ) {
          this.navServicio.setMesage( 0, {
            severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'PROCESOPRODUCTIVO.MSG_ERRORCODIGO' )
          } );
          this.guardando = false;
          this.submitted = false;
          this.carTabla = false;
        } else {
          /** Crear Variable incidencia */
          this.serProcesoVariableIncidencia.crear( formulario ).subscribe( reg => {
            this.lisVariablesIncidencias = [];
            this.serProcesoVariableIncidencia.obtenerPorProcesoProductivo( this.procesoProductivo.idProcesoProductivo ).subscribe( regActualizado => {
              this.lisVariablesIncidencias = regActualizado;
              this.guardando = false;
              this.submitted = false;
              this.carTabla = false;
              this.variableIncidencia = null;
              this.formulario.reset();
              this.f.idProcesoProductivo.setValue( this.procesoProductivo.idProcesoProductivo );
              this.f.indicadorHabilitado.setValue( true );
              this.navServicio.setMesage( 0, {
                severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
                detail: this.navServicio.buscarMensaje( 'ESTRUCTURAAGRICOLA.LBL_REGGUAR' )
              } );
            } );
          } );
        }
      }

    }
  }

  editar( reg: ProcesoVariableIncidencia ) {
    this.variableIncidencia = reg;
    this.formulario.reset();
    this.f.idProcesoProductivo.setValue( this.procesoProductivo.idProcesoProductivo );
    this.f.idProcesoVariableIncidencia.setValue( this.variableIncidencia.idProcesoVariableIncidencia );
    this.f.codigo.setValue( this.variableIncidencia.codigo );
    this.f.variableIncidencia.setValue( this.variableIncidencia.variableIncidencia );
    this.f.indicadorHabilitado.setValue( this.variableIncidencia.indicadorHabilitado );
  }

  verificarCodigo( item: ProcesoVariableIncidencia ): boolean {
    if ( item.idProcesoVariableIncidencia !== '' && item.idProcesoVariableIncidencia !== null && item.idProcesoVariableIncidencia !== undefined ) {
      return this.lisVariablesIncidencias.find( x => x.codigo === item.codigo && x.idProcesoVariableIncidencia !== item.idProcesoVariableIncidencia ) ? true : false;
    } else {
      return this.lisVariablesIncidencias.find( x => x.codigo === item.codigo ) ? true : false;
    }
  }


  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.router.navigate( [ 'ceu/estructura-pecuaria/' ] );
        },
        reject: () => {
        }
      } );
    } else {
      this.router.navigate( [ 'ceu/estructura-pecuaria/' ] );
    }
  }
}
